<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="(fromFacility ? 'PATIENT.RESIDENTS_LIST' : 'PATIENT.PATIENTS_LIST') | translate"
    [class]="'card-head-lg'"
  >
    <ng-container ktPortletTools>
      <div class="d-flex align-items-center">
        <ng-template ngxPermissionsOnly="accessToPatientImageChangeRequests">
          <button mat-raised-button (click)="viewImageRequests()" class="btn btn-primary mr-2">
            <span>{{ 'PATIENT.VIEW_IMAGE_REQUESTS' | translate }}</span>
          </button>
        </ng-template>
        <ng-template
          *ngIf="!(filteredView || fromDoctor || fromFacility)"
          ngxPermissionsOnly="canAddPatient"
        >
          <div
            style="
              border-radius: 4px !important;
              box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
                0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
            "
            class="btn-group"
          >
            <button
              mat-raised-button
              (click)="addPatient()"
              style="box-shadow: none !important"
              class="btn btn-primary"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
                class="svg-icon svg-icon-md"
              ></span>
              <span>{{ 'PATIENT.ADD_PATIENT' | translate }}</span>
            </button>
            <div class="btn-group">
              <button
                mat-raised-button
                matTooltip="Import from CSV"
                data-toggle="dropdown"
                style="
                  border-left: 1px solid rgba(255, 255, 255, 0.2) !important;
                  box-shadow: none !important;
                "
                class="btn btn-icon btn-primary dropdown-toggle"
              >
                <span
                  inlineSVG="assets/media/svg/icons/Navigation/Angle-down.svg"
                  class="svg-icon svg-icon-md"
                ></span>
              </button>
              <div class="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                <a class="dropdown-item" (click)="uploaderPatient.click()">
                  <form [formGroup]="uploadForm">
                    <i class="flaticon-users mr-3"></i>
                    Patients
                    <input
                      hidden
                      #uploaderPatient
                      #fileInput
                      type="file"
                      accept=".csv"
                      name="profile"
                      (change)="onFileChange($event)"
                    />
                  </form>
                </a>
                <a class="dropdown-item" (click)="uploaderInsurance.click()">
                  <form [formGroup]="uploadForm1">
                    <i class="flaticon-safe-shield-protection mr-3"></i>
                    Insurance
                    <input
                      hidden
                      #uploaderInsurance
                      #fileInput1
                      type="file"
                      accept=".csv"
                      name="profile1"
                      (change)="onFileChange1($event)"
                    />
                  </form>
                </a>
              </div>
            </div>
          </div>
        </ng-template>
        <button
          [disabled]="exporting"
          *ngIf="!filteredView"
          mat-raised-button
          matTooltip="Export as CSV"
          class="btn btn-icon btn-primary ml-2"
          (click)="exportPatientsAsCSV($event)"
        >
          <i class="fas fa-download"></i>
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <button
          style="width: 140px !important"
          class="btn btn-sm btn-light-{{ getItemCssClassByStatus(searchIsActiveSelect) }} mr-4"
          (click)="toggleStatus($event)"
        >
          {{ getItemStatusString(searchIsActiveSelect) }} Patients
        </button>
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetSearchInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table #sort="matSort" matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="entityId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'PATIENT.INPUT.ID' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let patient" class="gl-block">
            <span
              [matTooltip]="canViewPatient() ? 'View Patient' : null"
              [class.clickable]="canViewPatient()"
              (click)="viewPatientDblclick(patient.id, patient)"
              >{{ patient.patient_id }}</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchEntityId">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PATIENT.INPUT.ID' | translate }}</mat-label>
              <input
                matInput
                [placeholder]="'PATIENT.INPUT.ID' | translate"
                [(ngModel)]="searchEntityIdInput"
              />
              <button
                *ngIf="searchEntityIdInput"
                matSuffix
                mat-icon-button
                (click)="searchEntityIdInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="profile">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell
            *matCellDef="let patient"
            class="profile-pic gl-block clickable justify-content-center"
            (click)="showPatientPhoto(patient)"
          >
            <kt-user-photo
              [create]="'false'"
              [size]="30"
              [type]="'object'"
              [editable]="false"
              [user$]="{ profileUrl: patient.pre_signed_url?.url }"
              [entityTypeAndGender]="{ type: 'PATIENT', gender: patient.gender }"
            ></kt-user-photo>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchProfile">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'PATIENT.PATIENT' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let patient" class="gl-block flex-column align-items-start">
            <span
              [matTooltip]="canViewPatient() ? 'View Patient' : null"
              [class.clickable]="canViewPatient()"
              (click)="viewPatientDblclick(patient.id + patient.first_name, patient)"
            >
              {{ patient.first_name }} {{ patient.middle_name }} {{ patient.last_name }}
              {{ patient.last_name2 }}
            </span>
            <a href="mailto:{{ patient.email }}">{{ patient.email }}</a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchNameEmail">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PATIENT.INPUT.NAME_EMAIL' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchNameEmailInput"
                [placeholder]="'PATIENT.INPUT.NAME_EMAIL' | translate"
              />
              <button
                *ngIf="searchNameEmailInput"
                matSuffix
                mat-icon-button
                (click)="searchNameEmailInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="dob">
          <mat-header-cell *matHeaderCellDef mat-sort-header>DOB</mat-header-cell>
          <mat-cell *matCellDef="let patient" class="gl-block">{{
            patient.dob | date : 'MM/dd/yyyy'
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchDOB">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PATIENT.INPUT.DOB' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchDOBInput"
                [matDatepicker]="searchDOBPicker"
                [placeholder]="'PATIENT.INPUT.DOB' | translate"
              />
              <button
                *ngIf="searchDOBInput"
                matSuffix
                mat-icon-button
                (click)="searchDOBInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle
                *ngIf="!searchDOBInput"
                matSuffix
                [for]="searchDOBPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #searchDOBPicker></mat-datepicker>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="cellPhone">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'PATIENT.INPUT.CELL_PHONE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let patient" class="gl-block">{{
            patient.cell_phone | phoneFormat
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchCellPhone">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PATIENT.INPUT.CELL_PHONE' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchCellPhoneInput"
                [mask]="'(000) 000-0000'"
                [placeholder]="'PATIENT.INPUT.CELL_PHONE' | translate"
              />
              <button
                *ngIf="searchCellPhoneInput"
                matSuffix
                mat-icon-button
                (click)="searchCellPhoneInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="facility">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'PATIENT.INPUT.FACILITY' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let patient" class="gl-block">{{
            patient.facility_name
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchFacility">
          <mat-header-cell *matHeaderCellDef class="facility">
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PATIENT.INPUT.FACILITIES' | translate }}</mat-label>
              <input matInput #searchFacilityInput (input)="handleFacilityInput($event)" />
              <mat-select
                #searchFacilitySelect
                multiple
                style="width: 0 !important"
                (closed)="handleFacilityClose()"
              >
                <mat-option *ngFor="let facility of facilities$ | async" [value]="facility">{{
                  facility.name
                }}</mat-option>
              </mat-select>
              <button
                class="close-facility-button"
                *ngIf="searchFacilitySelect.value?.length > 0"
                matSuffix
                mat-icon-button
                (click)="emptyFacility()"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="isActive">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'PATIENT.INPUT.STATUS' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let patient">
            <span
              style="width: 61px"
              class="label label-lg label-light-{{
                getItemCssClassByStatus(patient.is_active.toString())
              }} label-inline text-center"
            >
              {{ getItemStatusString(patient.is_active.toString()) }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchIsActive">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PATIENT.INPUT.STATUS' | translate }}</mat-label>
              <mat-select
                [(value)]="searchIsActiveSelect"
                [placeholder]="'PATIENT.INPUT.STATUS' | translate"
                (selectionChange)="handleStatusChange()"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="true">Active</mat-option>
                <mat-option value="false">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="isHoldInHospital">
          <mat-header-cell *matHeaderCellDef>{{
            'PATIENT.INPUT.HOLD_HOSPITAL' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let patient" class="d-flex flex-center">
            <div style="height: 30px; width: 30px" class="d-flex flex-center mx-4">
              <span
                *ngIf="patient.hold_flag"
                matTooltip="Medications on Hold"
                inlineSVG="assets/media/svg/icons/General/pause.svg"
                class="svg-icon svg-icon-md"
              ></span>
            </div>
            <div style="height: 30px; width: 30px" class="d-flex flex-center mx-4">
              <span
                *ngIf="patient.in_hospital"
                matTooltip="Patient in Hospital"
                inlineSVG="assets/media/svg/icons/General/hospitalIcon.svg"
                class="svg-icon svg-icon-md"
              ></span>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchIsHoldInHospital">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PATIENT.INPUT.HOLD_HOSPITAL' | translate }}</mat-label>
              <mat-select
                [(value)]="searchIsHoldInHospitalSelect"
                [placeholder]="'PATIENT.INPUT.HOLD_HOSPITAL' | translate"
              >
                <mat-select-trigger>{{
                  (searchIsHoldInHospitalSelect | titlecase) || 'All'
                }}</mat-select-trigger>
                <mat-option value="">All</mat-option>
                <mat-option value="hold">Medications on Hold</mat-option>
                <mat-option value="hospital">Patient in Hospital</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let patient">
            <ng-template ngxPermissionsOnly="canViewPatient">
              <button
                matTooltip="{{ 'TABLE.VIEW' | translate }} Patient"
                class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                (click)="viewPatient(patient)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/visible.svg"
                  class="svg-icon svg-icon-md svg-icon-success"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canEditPatient">
              <button
                matTooltip="{{ 'TABLE.UPDATE' | translate }} Patient"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="editPatient(patient)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canActivatePatient">
              <button
                matTooltip="{{ 'TABLE.ACTIVATE_DEACTIVATE' | translate }} Patient"
                class="btn btn-icon btn-light btn-hover-warning btn-sm m-1"
                (click)="updateStatusForPatient(patient)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/update_icon2.svg"
                  class="svg-icon svg-icon-md svg-icon-warning"
                ></span>
              </button>
            </ng-template>
            <ng-template *ngIf="!fromFacility" ngxPermissionsOnly="canSoftDeletePatient">
              <button
                matTooltip="{{ 'TABLE.DELETE' | translate }} Patient"
                class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
                (click)="deletePatient(patient)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-danger"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarColumns"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="pageSize || 25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
